import type { NPCConfig } from '@/entities';

const config: NPCConfig[] = [
  // TODO satu invisible tile buat suara doang jumpscare
  {
    x: 1900,
    y: 1210,
    name: 'Elsa',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_elsa.png',
    flipSprite : true,
    repeatable : true,
    dialogTree: {
      startDialogId: 'elsa_1',
      nodes: {
        elsa_1: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Kamu dengar suara itu Yan?`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "elsa_2",
        },
        elsa_2: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Mungkin hanya perasaan ku saja`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          storyAction: { type: 'nextDay', value: 0 },
        }
      },
    },
  },
];

export default config;
